<script>
export default {
  props: {
    type: {
      type: String,
      default: 'success',
      validator: value => [
        'success', 'info', 'warning', 'error'
      ].includes(value)
    },
    title: {
      type: String,
      default: 'title:'
    },
    description: {
      type: String,
      default: 'description...'
    },
    colapsedMode: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showAlert: true,
      showIcon: false
    }
  },
  methods: {
    // Mostrar ícone com delay (para aparecer depois da transição do alert)
    alertVisibility () {
      if (this.showAlert) {
        this.showAlert = false
        this.showIcon = false
        setTimeout(() => {
          this.showIcon = true
        }, 400)
      } else {
        this.showAlert = true
        this.showIcon = false
      }
    }
  }
}
</script>

<template>
  <div>
    <transition name="fade-alert">
      <el-alert
        v-if="showAlert"
        :type="type"
        :title="title"
        :description="description"
        @close="colapsedMode ? alertVisibility() : ''"
        show-icon
        :closable="closable"
      />
    </transition>
    <transition name="fade-icon">
      <i
        v-if="colapsedMode && showIcon"
        @click="alertVisibility"
        :class="`el-alert__icon el-icon-${type} is-big el-alert--${type} is-light`"
        style="cursor: pointer; border-radius: 50%;"
        :title="description"
      ></i>
    </transition>
  </div>
</template>

<style scoped>
.fade-alert-enter-active, .fade-alert-leave-active {
  transition: opacity 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Alert/Alert.vue